<template>
  <div>
    <v-list-item>
      <v-tooltip top v-if="includeRefresh">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn v-on="tooltip" icon small @click="buildList()"><v-icon>mdi-refresh</v-icon></v-btn>
        </template>
        Refresh the list
      </v-tooltip>
      <slot name="filter"/>
      <v-spacer/>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn icon @click="print" v-on="on"><v-icon>mdi-printer</v-icon></v-btn>
        </template>
        Print the list
      </v-tooltip>

      <v-tooltip top v-if="$store.getters.company.allowCSVExport">
        <template v-slot:activator="{on}">
          <v-btn v-if="downloadEndpoint" icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
        </template>
        Export all items as a CSV file
      </v-tooltip>

      <customize-table :name="name" :headers="headers" :defaultColumns="defaultColumns"
                       :columns.sync="columns" :dense.sync="dense" :divider.sync="divider"/>

      <v-menu v-if="!!this.$slots.menu" bottom max-width="350" nudge-bottom="5" :open-on-click="false" :close-on-click="false" :close-on-content-click="false" content-class="tour-arrow tour-arrow-right purple white--text pt-6 px-4" transition="slide-y-transition" :value="showHint">
        <template v-slot:activator="{on:tour}">

          <v-menu offset-y eager nudge-width="200">
            <template v-slot:activator="{ on:commands }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn small icon v-on="{...commands, ...tooltip}" v-on:click.prevent><v-icon>mdi-cog-outline</v-icon></v-btn>
                </template>
                {{title}} operations
              </v-tooltip>
            </template>
            <v-list dense>
              <slot name="menu"/>
            </v-list>
          </v-menu>

        </template>
        List items usually have a menu (<v-icon small color="white">mdi-dots-vertical</v-icon>) with item specific commands.
        <div class="mt-2">
          Most lists also have a menu of commands that are not specific to any item in the list,
          but relevant to the information you are looking at.
        </div>
        <div>
          <v-btn plain class="white--text mt-4 float-right" @click.stop="doneHint()">Got it</v-btn>
        </div>
      </v-menu>

    </v-list-item>

    <v-data-table ref="table" class="purtrak-table"
                  :items="list"
                  :disable-pagination="!!nonPagedItems" :hide-default-footer="!!nonPagedItems"
                  :headers="activeHeaders"
                  fixed-header
                  calculate-widths
                  :height="height"
                  :dense="dense"
                  :loading="loading"
                  :footer-props="footerProps"
                  :item-class="item => itemClass(item) + (item[itemKey] === selectedId ? ($vuetify.breakpoint.mobile ? ' selected-list-item-mobile':' selected-list-item') : '')"
                  :page.sync="page"
                  :items-per-page.sync="pageSize"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-data-text="'No ' + objectType + ' found'"
                  :loading-text="'Loading ' + objectType"
                  :mobile-breakpoint="$vuetify.breakpoint.mobileBreakpoint"
                  :show-expand="!$vuetify.breakpoint.mobile && showExpand" single-expand
                  :expanded.sync="expanded"
                  :show-select="showSelect"
                  v-model="selected"
                  :options.sync="options"
                  :server-items-length="items.totalCount"
                  @toggle-select-all="({items}) => items.forEach(item => delete item._error)"
                  @click:row="item => selectedId = item[itemKey]"
                  @dblclick:row="(e,info) => $emit('dblclick', info.item)"
                  @item-expanded="({item, value}) => {selectedId = item[itemKey]; $emit('itemExpanded', {item, value})}">
      <template v-slot:item.data-table-select="{isSelected,select,item}">
        <v-tooltip color="error" right :disabled="!item._error">
          <template v-slot:activator="{on}">
            <v-simple-checkbox v-model="isSelected" @input="select(isSelected);delete item._error" v-on="on"
                              :color="item._error ? 'error' : ''"/>
          </template>
          {{item._error}}
        </v-tooltip>
      </template>
      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomizeTable from '@/components/CustomizeTable'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'PurtrakTable',
  mixins: [printHtml],
  components: {CustomizeTable},
  props: {
    nonPagedItems: {type:Array, required:false},  // Instead of paging, list items to show
    value: {type:Array, required:false},  // Selected items
    name: {type:String, required:true},   // For localstorage of parms
    title: {type:String, required:true},   // For printing and tooltip description
    objectType: {type:String, required:false, default:'items'},
    defaultColumns: {type:Array, required:true},
    headers: {type:Array, required:true},
    includeRefresh: {type:Boolean, required:false, default:false},
    api: {type:String, required:false, default:'purtrak'},
    hideAction: {type:Boolean, required:false, defualt:false},
    listEndPoint: {type:[String,Function], required:true},
    fields: {type:String, required:true},
    totalFields: {type:String, required:false, default:''},
    totals: {type:Object, required:false},
    listFilters: {type:Array, required:false},
    parameters: {type:Array, required:false},
    itemKey: {type:String, required:false, default:'id'},
    itemClass: {type:Function, required:false, default: () => ''},

    height: {type:String, required:false, default:'calc(100vh - 212px)'},
    showSelect: {type:Boolean, required:false, default:false},
    showExpand: {type:Boolean, required:false, default:false},

    printInfo: {type:Object, required:true},
    downloadEndpoint: {type:[String,Function], required:false}
  },
  data() {
    return {
      columns: [],
      items: {edges:[]},
      loading: false,
      dense: false,
      divider: false,
      selectedId: null,
      page: 1,
      pageSize: 0,
      sortBy: [''],
      sortDesc: [false],
      selected: [],
      options: {},
      expanded: []
    }
  },
  computed: {
    list() {
      return this.nonPagedItems ?? this.listItems;
    },
    showHint() {
      return this.$store.getters.userSettings.listMenuHint;
    },
    footerProps() {
      return {itemsPerPageText:`${this.objectType.charAt(0).toUpperCase()+this.objectType.slice(1)} per page`,
              showFirstLastPage:true,
              itemsPerPageOptions:[25,50,100]}
    },
    activeHeaders() {
      const headers = [];
      if (this.showSelect)
        headers.push({ text: '', value: 'data-table-select', width:'1%',sortable:false,print:false,class:'pl-2 pr-0',cellClass:'pl-2 pr-0',align:'center'});
      if (this.showExpand)
        headers.push({ text: '', value: 'data-table-expand', width:'1%',sortable:false,print:false,class:'pl-1 pr-0',cellClass:'pl-1 pr-0'});
      this.columns.forEach(column => {
        if (column.visible) {
          const header = this.headers.find(header => header.value === column.value);
          if (!header.omit?.()) {
            if (column.size) {
              header.originalWidth = header.width;
              header.width = `${column.size}%`;
            }
            header.divider = this.divider;
            headers.push(header);
          }
        }
      });
      if (!this.hideAction)
        headers.push({ text: '' , value:'action', width:'5%',sortable:false,align:'center',print:false});
      return headers;
    },
    listItems() {
      return this.items.edges.map(edge => edge.node);
    }
  },
  watch: {
    selected() {
      this.$emit('input', this.selected);
    },
    pageSize() {
      localStorage.setItem(`${this.name}.pageSize`, this.pageSize);
    },
    sortBy() {
      localStorage.setItem(`${this.name}.sortBy`, this.sortBy[0] || '');
      this.$emit('update:sortBy', this.sortBy[0] ?? '');
    },
    sortDesc() {
      localStorage.setItem(`${this.name}.sortDesc`, this.sortDesc[0]?'1':'0');
    },
    options: {
      handler () {
        this.buildList();
      },
      deep: true,
    },
    listFilters() {
      this.options.page = 1;
      this.buildList();
    },
    parameters() {
      this.options.page = 1;
      this.buildList();
    }
  },
  created() {
    this.pageSize = parseInt(localStorage.getItem(`${this.name}.pageSize`) || 25);
    this.sortBy[0] = localStorage.getItem(`${this.name}.sortBy`);
    this.sortDesc[0] = localStorage.getItem(`${this.name}.sortDesc`) === '1';
    this.$emit('update:sortBy', this.sortBy[0]);
  },
  mounted() {
    if (!this.columns.find(column => column.value === this.sortBy[0])?.visible) {
      this.sortBy[0] = '';
      this.sortDesc[0] = false;
    }
    this.$emit('update:sortBy', this.sortBy[0]);
  },
  methods: {
    doneHint() {
      delete this.$store.getters.userSettings.listMenuHint;
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    },
    buildList(errors = []) {
      const totalPages = Math.ceil(this.items.totalCount / this.options.itemsPerPage);
      if (!this.listFilters)
        return;
      if (this.options.page === 1)
        this.getData(true, '', this.options.itemsPerPage, errors);
      else if (this.options.page === totalPages)
        this.getData(false, '', this.items.totalCount - (this.options.page - 1) * this.options.itemsPerPage, errors);
      else if (this.options.page > this.page)
        this.getData(true, this.items.pageInfo.endCursor, this.options.itemsPerPage, errors);
      else
        this.getData(false, this.items.pageInfo.startCursor, this.options.itemsPerPage, errors);
    },

    async getData(after, cursor, pageSize, errors) {
      this.loading = true;

      // Must close expanded item since underlying object with data will be replaced
      if (this.expanded.length)
        this.expanded.splice(0, 1);
      this.selected = [];

      if (this.listEndPoint instanceof Function)
        this.items = await this.listEndPoint(after, cursor, pageSize, this.listFilters, this.parameters, this.options);

      else {
        const results = await this.$apiCall(`query ${this.listEndPoint}PurtrakTable($after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                                  ${this.listEndPoint}(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                    totalCount
                                                    ${this.totalFields}
                                                    pageInfo {
                                                      hasPreviousPage
                                                      hasNextPage
                                                      startCursor
                                                      endCursor
                                                    }
                                                    edges {
                                                      cursor
                                                      node {
                                                        ${this.fields}
                                                      }
                                                    }
                                                  }
                                                }`,
                                            {after:after?cursor:null, first:after?pageSize:null,
                                              before:!after?cursor:null, last:!after?pageSize:null,
                                              filters:this.listFilters, parameters:this.parameters,
                                              sortKey:this.options.sortBy[0], reverse:this.options.sortDesc[0]},
                                            false, this.api);

        this.items = results.data[this.listEndPoint];
        if (this.totals) {
          const totals = {};
          for (const [key, value] of Object.entries(this.totals))
            totals[key] = this.items[key];
          this.$emit('update:totals', totals);
        }
        this.$emit('list', {list:this.items, sortBy:this.options.sortBy[0]});
      }
      errors.forEach(error => {
        const listItem = this.listItems.find(item => item.id === error.id);
        if (listItem) {   // In case reactive operation remove the item from the list
          this.value.push(listItem);
          this.$set(listItem, '_error', error.error);
        }
      });
      this.loading = false;
    },

    print() {
      const table = this.$refs.table;
      let subTitle = '';
      if (typeof this.printInfo.subTitle === 'string')
        subTitle = this.printInfo.subTitle
      else if (!!this.printInfo.subTitle)
        subTitle = this.printInfo.subTitle.filter(s => s).join(', ');

      const columns = this.activeHeaders.reduce((columns, column) =>
        columns + ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? 1 : 0), 0);
      const lines = [
              `<table style="width:100%;border-spacing:0">
                <thead>
                  <tr>
                    <th colspan="${columns}" class="sup-title">${this.$store.getters.company.name}</th>
                  </tr>
                  <tr>
                    <th colspan="${columns}" class="title">${this.title}</th>
                  </tr>
                  <tr>
                    <th colspan="${columns}" class="sub-title">${subTitle}</th>
                  </tr>
                 <tr class="header">`];
        this.activeHeaders.forEach(column => {
          if ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none')) {
            const slot = table.$scopedSlots['header.'+column.value];
            const title = slot ? slot({printing:true})[0].text??'' : column.text;
            lines.push(`<th style="width:${(column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? column.width : '0%'};text-align:${column.align ? column.align : 'left'}">${title}</th>`);
          }
        })
        lines.push('</tr></thead>');
        lines.push('<tbody>');
        this.list.forEach(item => {
          lines.push('<tr>')
          this.activeHeaders.forEach(column => {
            if ((column.print == undefined || column.print) && (!column.align || column.align !== ' d-none')) {
              let value = item;
              column.value.split('.').forEach(key => value = value ? value[key] : '');

              const slot = table.$scopedSlots['item.'+column.value];
              if (slot) {
                const slotA = slot({item,value,printing:true});
                value = slotA ? slotA[0].text : '';
              }
              if (value == null || value == undefined)
                value = "";
              lines.push(`<td style="width:${(column.print == undefined || column.print) && (!column.align || column.align !== ' d-none') ? column.width : '0%'};text-align:${column.align ? column.align : 'left'}">${value}</td>`);
            }
          })
          lines.push('</tr>')
        })

      if (table.$scopedSlots['body.appendPrint'])
        lines.push(this._htmlFromVNode(table.$scopedSlots['body.appendPrint']()[0]));
      else if (table.$scopedSlots['body.append'])
        lines.push(this._htmlFromVNode(table.$scopedSlots['body.append']({headers:this.activeHeaders,printing:true})[0]));

      lines.push('</tbody></table>');
      this.printHtml(this.title, `<!DOCTYPE html>
                            <html>
                              <head>
                                <style>
                                  @page {size:${this.printInfo.pageSize}}
                                  body {font-family: Roboto, sans-serif; font-size:14px}
                                  th,td {height:36px;padding:0 16px}
                                  .title {font-size:18px;text-transform:uppercase}
                                  .sup-title {font-weight:normal;font-size:22px}
                                  .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                                  .header th {border-bottom:1px solid #000;margin-bottom:20px}
                                  .text-right {text-align:right}
                                  .font-weight-bold {font-weight:bold}
                                  .total-row {font-weight:bold}
                                </style>
                              </head>
                              <body>
                                ${lines.join('')}
                              </body>
                            </html>`);
    },
    _htmlFromVNode(vNode) {
      if (vNode.tag) {
        let childrenHTML = '';
        if (vNode.children) {
          for (const child of vNode.children)
            childrenHTML += this._htmlFromVNode(child);
        }
        let attrs = '';
        if (vNode.data && vNode.data.attrs) {
          for (const attr in vNode.data.attrs)
            attrs += ` ${attr}="${vNode.data.attrs[attr]}"`;
        }
        return `<${vNode.tag} class="${vNode.data && vNode.data.staticClass ? vNode.data.staticClass : ''}"${attrs}>${childrenHTML}</${vNode.tag}>`;
      }
      if (vNode.text)
        return vNode.text;
      return '';
    },

    async exportCSV() {
      this.loading = true;
      if (this.downloadEndpoint instanceof Function)
        this.download(await this.downloadEndpoint(this.listFilters, this.parameters, this.options));

      else {
        const results = await this.$apiCall(`query ${this.downloadEndpoint}PurtrakTable($filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                                  ${this.downloadEndpoint}(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                                }`,
                                            {filters:this.listFilters, parameters:this.parameters,
                                            sortKey:this.options.sortBy[0], reverse:this.options.sortDesc[0]},
                                            false, this.api);
        if (!results.error)
          this.download(results.data[this.downloadEndpoint]);
      }
      this.loading = false;
    },

    async download(file) {
      const response = await fetch(file);
      const blob = await response.blob();
      const blobURL = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.style = 'display: none';
      link.download = new URL(file).pathname.split("/").pop();
      link.click();
    }

  }
}
</script>